import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getAssociationCommitteeSummaries: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/:associationId/committees`,
    },

    getAssociationActiveCommitteeOptions: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/:associationId/committees/activeOptions`,
    },

    createAssociationCommittee: {
        method: 'POST',
        url: `${BASE_PATH_API}/associations/:associationId/committees`,
    },

    getAssociationCommittee: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/:associationId/committees/:committeeId`,
    },

    updateAssociationCommittee: {
        method: 'PUT',
        url: `${BASE_PATH_API}/associations/:associationId/committees/:committeeId`,
    },

    updateAssociationCommitteeStatus: {
        method: 'PUT',
        url: `${BASE_PATH_API}/associations/:associationId/committees/:committeeId/isActive`,
    },

    deleteAssociationCommittee: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/associations/:associationId/committees/:committeeId`,
    },

    getAssociationCommitteeMembers: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/:associationId/committees/:committeeId/members`,
    },

    getAssociationActiveCommitteeMembers: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/:associationId/committees/:committeeId/members/activeOptions`,
    },

    getCommitteeMemberHasArcApproval: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/:associationId/committees/:committeeId/members/:committeeMemberTermId/hasPendingArcApprovals`,
    },

    getCommitteeMemberHasArcApprovalWithStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/:associationId/committees/:committeeId/members/:committeeMemberTermId/hasArcApprovalsWithStatus`,
        params: { 'approvalStatus': 'approvalStatus' }
    },

    createAssociationCommitteeMember: {
        method: 'POST',
        url: `${BASE_PATH_API}/associations/:associationId/committees/:committeeId/members`,
    },

    deleteAssociationCommitteeMemberTerm: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/associations/:associationId/committees/:committeeId/members/:committeeMemberTermId`,
    },

    getAssociationCommitteeMemberTerm: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/:associationId/committees/:committeeId/members/:committeeMemberTermId`,
    },

    updateAssociationCommitteeMemberTerm: {
        method: 'PUT',
        url: `${BASE_PATH_API}/associations/:associationId/committees/:committeeId/members/:committeeMemberTermId`,
    },

    getAssociationOwnerCommitteeMemberTerms: {
        method: 'GET',
        url: `${BASE_PATH_API}/users/associationOwners/:associationOwnerId/committeeMemberTerms`,
    },

    getAssociationArchitecturalRequestCommitteeId: {
        method: 'GET',
        url: `${BASE_PATH_API}/associations/:associationId/committees/architecturalRequestCommittee`,
    },
};

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function AssociationCommitteesApi() {
    return createActions(actions);
}
